/**
 * Shared constants for robots.txt compliance status of information sources.
 * Used by both the sources list page and the filter dropdown to ensure
 * label consistency.
 */

/** Possible values for robots.txt compliance status per source. */
export enum RobotsTxtStatus {
  ALLOWED = "ALLOWED",
  DISALLOWED = "DISALLOWED",
  NO_ROBOTS_TXT = "NO_ROBOTS_TXT",
  ERROR = "ERROR",
  NOT_CHECKED = "NOT_CHECKED",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

/** Polish display labels for robots.txt status values. */
export const ROBOTS_TXT_STATUS_LABELS: Record<RobotsTxtStatus, string> = {
  [RobotsTxtStatus.ALLOWED]: "Dozwolony",
  [RobotsTxtStatus.DISALLOWED]: "Zablokowany",
  [RobotsTxtStatus.NO_ROBOTS_TXT]: "Brak robots.txt",
  [RobotsTxtStatus.ERROR]: "Błąd",
  [RobotsTxtStatus.NOT_CHECKED]: "Nie sprawdzono",
  [RobotsTxtStatus.NOT_APPLICABLE]: "Nie dotyczy",
};
